<template>
    <span :style="{ backgroundColor: bgColor }" :class="['deadline-reminder', !deadlineExpired ? 'active' : 'expired']"
        >The deadline {{ deadlineExpired ? 'was' : 'is' }} {{ deadlineToLocal | moment('LLL') }}</span
    >
</template>
<script>
import { mapGetters } from 'vuex';
export default {
    props: {
        bgColor: {
            type: String,
            default: '#f3f4f6',
        },
    },
    computed: {
        ...mapGetters('tributeVideo', ['deadlineExpired', 'deadlineToLocal']),
    },
};
</script>
<style lang="scss" scoped>
.deadline-reminder {
    // background: #f3f4f6;
    border-radius: 20px;
    padding: 5px 16px;
    display: flex;
    align-items: center;
    gap: 8px;

    &::before {
        content: '';
        display: inline-block;
        background: $primary-grey;
        width: 6px;
        height: 6px;
        border-radius: 100%;
    }
    &.active {
        &::before {
            background: $medium-green;
        }
    }
    &.expired {
        &::before {
            background: $medium-red;
        }
    }
}
</style>
